import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
// INITIAL STATE
const initialState = {
    contacts: [],
    pagination: {
        count: 0,
        active: 0,
        inactive: 0,
        total: 0,
        page: 1,
        totalPages: 1,
        limit: 20,
    },
    loading: false,
    error: null,
};
// ASYNC THUNKS
export const fetchOptOutContacts = createAsyncThunk("optOutContact/fetchList", async (params, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const p = (params || {});
        const query = new URLSearchParams();
        query.set("page", String(p.page ?? 1));
        query.set("limit", String(p.limit ?? 20));
        if (p.searchText)
            query.set("searchText", p.searchText);
        if (p.status)
            query.set("status", p.status);
        if (p.sortBy)
            query.set("sortBy", p.sortBy);
        if (p.sortOrder)
            query.set("sortOrder", p.sortOrder);
        const response = await ApiCall("GET", `/api/opted-out-contacts?${query.toString()}`, "", { Authorization: token });
        const data = response?.data;
        if (data?.success) {
            return {
                contacts: data.data?.optedOutContacts || [],
                pagination: data.data?.pagination || initialState.pagination,
            };
        }
        return rejectWithValue(data?.message || "Failed to fetch opted out contacts");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
export const fetchOptOutContactById = createAsyncThunk("optOutContact/fetchById", async (id, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const response = await ApiCall("GET", `/api/opted-out-contacts/${id}`, "", {
            Authorization: token,
        });
        const data = response?.data ?? response?.response?.data;
        if (data?.success)
            return data.data;
        return rejectWithValue(data?.message || "Failed to fetch opted out contact");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
export const createOptOutContact = createAsyncThunk("optOutContact/create", async (payload, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const response = await ApiCall("POST", "/api/opted-out-contacts", payload, {
            Authorization: token,
        });
        const data = response?.data ?? response?.response?.data;
        if (data?.success)
            return data.data;
        return rejectWithValue(data?.message || "Failed to create opted out contact");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
export const updateOptOutContact = createAsyncThunk("optOutContact/update", async ({ id, payload }, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const response = await ApiCall("PUT", `/api/opted-out-contacts/${id}`, payload, {
            Authorization: token,
        });
        const data = response?.data ?? response?.response?.data;
        if (data?.success)
            return data.data;
        return rejectWithValue(data?.message || "Failed to update opted out contact");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
export const deleteOptOutContact = createAsyncThunk("optOutContact/delete", async (id, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth?.token || "";
        const response = await ApiCall("DELETE", `/api/opted-out-contacts/${id}`, null, {
            Authorization: token,
        });
        const data = response?.data ?? response?.response?.data;
        if (data?.success)
            return id;
        return rejectWithValue(data?.message || "Failed to delete opted out contact");
    }
    catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message || "An error occurred");
    }
});
// SLICE
const optOutContactSlice = createSlice({
    name: "optOutContact",
    initialState,
    reducers: {
        clearOptOutContactError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOptOutContacts.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchOptOutContacts.fulfilled, (state, action) => {
            state.loading = false;
            state.contacts = action.payload.contacts;
            state.pagination = action.payload.pagination;
        })
            .addCase(fetchOptOutContacts.rejected, (state, action) => {
            state.loading = false;
            state.contacts = [];
            state.error = action.payload || "Failed to fetch opted out contacts";
        });
    },
});
export const { clearOptOutContactError } = optOutContactSlice.actions;
// SELECTORS
export const selectOptOutContacts = (state) => state.optOutContact.contacts;
export const selectOptOutContactPagination = (state) => state.optOutContact.pagination;
export const selectOptOutContactLoading = (state) => state.optOutContact.loading;
export default optOutContactSlice.reducer;
